<div class="fixed-menu">
  <div
    #menu
    class="left-menu-container no-print"
    [class.locked]="isScrollbarLocked$ | async"
    [class.left-menu-container--fixed]="isSticky"
  >
    <div class="left-menu-container-scroll">
      <ng-content select="[fixed-menu]"></ng-content>
    </div>
  </div>
  <div class="workspace-container"><ng-content select="[fixed-menu-workspace]"></ng-content></div>
</div>
